export default __webpack_public_path__ + "static/media/FakeImage.a94c1e43.svg";